export enum Capability {
  labelable             = 1,
  placeholderable       = 2,
  requireable           = 3,
  formatable            = 4,
  lengthable            = 5,
  numericMinMaxable     = 6,
  dateMinMaxable        = 7,
  referenceable         = 8,
  helpTextable          = 9,
  repeatable            = 10,
  layoutable            = 11,
  sizeableFont          = 12,
  fileMode              = 13,
  columnable            = 14,
  // payment               = 15, TODO: Deprecated payment form control
  pageBreak             = 16,
  defaultOption         = 17,
  layoutContainer       = 18,
  defaultable           = 19,
  maskable              = 20,
  checkByDefault        = 21,
  readonlyable          = 22,
  showHideable          = 23,
  optionRangeRequirable = 24,
  sortable              = 25,
  destroyable           = 26,
  thirdPartyCompleter   = 27,
  selectable            = 28,
  indexable             = 29,
  wysiwygLabelable      = 30,
  verticalAlign         = 31,
  resizable             = 32,
  dataReferencable      = 33,
  profileConfig         = 34,
  subreferenceable      = 35,
  validationRule        = 36,
  displayLableable = 37,
  wysiwygFormattable = 38,
  container = 39, // anything that can contain other form element
  signature = 40,
  validationMode = 41, // page break config for form section
}
